export default {
	lang:'tw',
	download:{
		"download01": 'Windows',
		 "download02": 'Mac',
		 "download03": 'iOS',
		 "download04": 'Android',
		 "download05": '立即下載',
		 "download": '下載',
		 "download2": '行動裝置',
		 "download3": '手機掃碼下載 iOS/Android',
		 "download4": '二維碼',
		 "download5": 'Windows',
		 "download6": '支援64位元Windows 10以上',
		 "download7": 'macOS',
		 "download8": '支援MacOS 10.14以上',
		 "download9": 'App Store',
		 "download10": '支援MacOS 10.14以上',
		 "download11": 'Android',
		 "download12": '支援Android 10.14以上',
	},
	home:{
		"home": '首頁',
		 "XiaobeiBigModel": '小貝大模型',
		 "AIcapability": 'AI能力',
		 "Solution": '解決方案',
		 "ProductCenter": '產品中心',
		 "MediaCenter": '媒體中心',
		 "AboutUs": '關於我們',
		 "Login/Regis": '登入/註冊',
		 "home1": '核心能力',
		 "home2": '客服電話',
		 "home3": '聯絡電話',
		 "home14": 'AI賦能，以智慧硬體為載體，提供全端能力與服務',
		 "home15": '拼圖演算法',
		 "home16": 'OCR識別',
		 "home17": 'AI智能',
		 "home18": '語音辨識',
		 "home19": '權威字典',
		 "home20": '文字翻譯',
		 "home21": '拍照翻譯',
		 "home22": '全科答疑',
		 "home23": '視訊課程',
		 "home24": '小貝AI大模型',
		 "home25": '技術是第一個生產力',
		 "home26": '技術人員',
		 "home27": '研發投入',
		 "home28": '專利數量',
		 "home29": '(佔比)',
		 "home30": '(億元)',
		 "home31": '(項)',
		 "home32": '解決方案',
		 "home33": '面對辦公室、教育、車盒多場景應用需求，貝鉑基於自身的研發能力和服務理念，為客戶提供一站式解決方案',
		 "home34": '相關解決方案',
		 "home35": '相關產品能力',
		 "home36": '全棧服務',
		 "home37": 'AI賦能，以智慧硬體為載體，提供全端能力與服務',
		 "home38": '研發',
		 "home39": '生產',
		 "home40": '品質管理',
		 "home41": '售後支援',
		 "home42": '專業軟硬體研發團隊，多年OCR、語音辨識、翻譯、AI、人機互動研發能力',
		 "home43": '源頭工廠，穩定供應鏈，嚴格智慧製程製作',
		 "home44": '質檢人員環環把關，導入ISO9001管理系統',
		 "home45": '在國內外建立專業售後支援團隊，及時回應，重點解決，一對一服務。 ',
		 "home46": '資格認證',
		 "home47": '100多項國內外專利',
		 "home48": '新聞資訊',
		 "home49": '了解我們最新動態',
		 "home50": '看詳情',
		 "home51": '合作夥伴',
		 "home52": '聚焦人工智慧硬體市場，提供專業OEM/0DM服務',
		 "home53": '合作諮詢',
		 "home54": '智慧辦公',
		 "home55": '智慧教育',
		 "home56": '智慧車盒',
		 "home57": '語音辨識',
		 "home58": '拼圖演算法',
		 "home59": 'OCR識別',
		 "home60": '語音合成',
		 "home61": '文字翻譯',
		 "home62": '圖片翻譯',
		 "home63": '語音翻譯',
		 "home64": '自然語言處理技術',
		 "home571": 'OCR識別',
		 "home581": '語音辨識 ',
		 "home591": '語音翻譯',
		 "home601": '語音合成',
		 "home611": '權威字典',
		 "home621": '全科課程',
		 "home631": '全科答疑',
		 "home641": '自然語言處理技術',
		 "home572": '語音辨識',
		 "home582": '語音合成 ',
		 "home592": '語音翻譯',
		 "home602": '自然語言處理技術',
		 "home603": '沒有更多',
	},
	consult:{
		"tilte":"我們將竭誠為您提供全方位的商務合作服務",
		 "subtilte":"請留下您的聯絡方式，我們將盡快與您聯絡",
		 "name":"請輸入您的姓名",
		 "phone":"請輸入您的手機",
		 "mailbox":"請輸入您的信箱",
		 "mailboxerr":"信箱格式錯誤",
		 "company":"請輸入您的公司",
		 "desc":"請輸入您的需求",
		 "but":"確認提交",
		 "region":"中國",
		 "select":"請選擇",
		 "submitSuccess":"提交成功",
		 "submitError":"提交失敗",
	},
	ProDetails:{
		"ProDetails1": '客製化流程',
		"ProDetails2": '聚焦人工智慧硬體市場，提供專業OEM/0DM服務',
	},
	aiCapacity:{
		"aiMode1": 'AI能力',
		 "aiMode2": '基於大數據、知識圖譜、機器學習、語言學等技術，我們不斷銳意創新， 潛心鑽研AI核心技術與智慧硬體應用落地。 ',
		 "aiMode3": '合作諮詢',
		 "aiMode4": '核心能力',
		 "aiMode5": 'AI賦能，以智慧硬體為載體，提供全端能力與服務',
		 "aiMode6": '拼圖演算法',
		 "aiMode7": '將零碎小圖合併成大圖識別，支援50+ 語種',
		 "aiMode8": 'OCR識別',
		 "aiMode9": '透過影像處理和模式識別技術擷取文字。支援50+ 語種',
		 "aiMode10": '語音辨識',
		 "aiMode11": '將長短音訊精確地辨識成文字。支持130+ 語種',
		 "aiMode12": '語音合成',
		 "aiMode13": '將文字轉換為自然流暢的人聲。支持130+ 語種',
		 "aiMode14": '文字翻譯',
		 "aiMode15": '將文字從目標語言轉換為指定語言。支持130+ 語種',
		 "aiMode16": '圖片翻譯',
		 "aiMode17": '圖片文字的辨識與翻譯。支持130+ 語種',
		 "aiMode18": '語音翻譯',
		 "aiMode19": '將長短音訊精準辨識並翻譯。支持130+ 語種',
		 "aiMode20": '自然語言處理技術',
		 "aiMode21": '基於大數據、知識、語言技術理解實現問答、對話等應用',
		 "aiMode22": '字典權威',
		 "aiMode23": '與權威機構深度合作，提供牛津、朗文、各小語等正版字典',
		 "aiMode24": '影片課程',
		 "aiMode25": '全科影片課程，教材同步更新，適合預習、複習',
		 "aiMode26": '全科答案',
		 "aiMode27": '全科答疑解譯，舉一反三訓練，提升學習效率',
		 "aiMode28": '小貝AI大模型',
		 "aiMode29": '多模互動',
		 "aiMode30": '文字、語音、視訊多模互動',
		 "aiMode31": '程式碼能力',
		 "aiMode32": '程式碼產生、解釋、糾錯、測試',
		 "aiMode33": '文字生成',
		 "aiMode34": '作文、行銷、新聞稿等生成',
		 "aiMode35": '全科能力',
		 "aiMode36": '全學段學科出題、解題',
		 "aiMode37": '語言理解',
		 "aiMode38": '摘要提取、語法檢查、情緒分析',
		 "aiMode39": '知識問答',
		 "aiMode40": '生活、工作、醫學和歷史知識',
		 "aiMode41": '邏輯推理',
		 "aiMode42": '思考、科學、常識推理',
		 "aiMode43": '多語言',
		 "aiMode44": '支援 100 多種語言互動',
		 "aiMode45": '技術優勢',
		 "aiMode46": '2億精準語料',
		 "aiMode47": '廣泛應用於智慧辦公室、智慧教育、智慧車盒',
		 "aiMode48": '全球協同技術',
		 "aiMode49": '超低延遲  安全穩定   智慧調度 連結穩定',
		 "aiMode50": '安全加密體系',
		 "aiMode51": '國際領先的雲-管-端-數四維加密體系，全過程加密',
	},
	aiMode:{
		"aiMode1": '小貝AI大模型',
		 "aiMode2": '基於大規模神經網路訓練的自然語言處理模型，具有自然語言理解、自然語言生成，對話互動、知識問答、文學創作等多種能力。釋放創造力，流簡化工作流程，為智慧硬體賦能。 ',
		 "aiMode3": '合作諮詢',
		 "aiMode4": '多元化能力',
		 "aiMode5": 'AI賦能，以智慧硬體為載體，提供全端能力與服務',
		 "aiMode6": '多模互動',
		 "aiMode7": '文字、語音、視訊多模互動',
		 "aiMode8": '程式碼能力',
		 "aiMode9": '程式碼產生、解釋、糾錯、測試',
		 "aiMode10": '文字生成',
		 "aiMode11": '作文、行銷、新聞稿等生成',
		 "aiMode12": '全科能力',
		 "aiMode13": '全學段學科出題、解題',
		 "aiMode14": '語言理解',
		 "aiMode15": '摘要提取、語法檢查、情緒分析',
		 "aiMode16": '知識問答',
		 "aiMode17": '生活、工作、醫學和歷史知識',
		 "aiMode18": '邏輯推理',
		 "aiMode19": '思考、科學、常識推理',
		 "aiMode20": '多語言',
		 "aiMode21": '支援 100 多種語言互動',
		 "aiMode22": '我們的優勢',
		 "aiMode23": '擬人聲語音互動',
		 "aiMode24": '模擬人類語音特徵、語調和語言風格，讓人機對話更加自然和親切，提升用戶體驗',
		 "aiMode25": '一鍵智能寫作',
		 "aiMode26": '面向剛需場景，打造「高效率、易用、智慧」的辦公室效率工具。 AI一鍵寫作、校準，讓工作總結與報告輕鬆高效，AI時代的效率利器',
		 "aiMode27": '全場景智慧助理',
		 "aiMode28": '整合了多種功能和服務的智慧助理應用，為使用者提供全方位的支援和便利',
		 "aiMode29": '快速回應',
		 "aiMode30": '高效率處理',
		 "aiMode31": '採用串流的介面設計,首幀回應最快可達毫秒。借助高效能演算法與架構，能在極短時間處理大量用戶需求',
		 "aiMode32": '多元場景',
		 "aiMode33": '持續進化',
		 "aiMode34": '提供包括語言理解、知識問答、代碼編寫、邏輯推理、數學解題等多元能力,持續從海量數據和知識中學習與進化',
		 "aiMode35": '彈性應用程式',
		 "aiMode36": '個性客製化',
		 "aiMode37": '提供豐富的參數設置，可以實現個人化的模型體驗。針對企業級的客製化需求，可以提供專屬的模型解決方案',
		 "aiMode38": '服務穩定',
		 "aiMode39": '安全可靠',
		 "aiMode40": '雲端服務達到等保三級標準,並採用千億級流量的公有雲架構，結合資料加密與存取控制等多重手段確保用戶隱私安全',
	},
	Product:{
		"Product1": '產品中心',
		"Product2": '辦公室、教育、車載智慧產品，支援訂購、功能客製化',
		"Product3": '合作諮詢',
	},
	medium:{
		"medium1": '媒體中心',
		"medium2": '貝鉑最新消息，看這裡',
		"medium3": '合作諮詢',
	},
	about:{
		"about1": '了解貝鉑',
		 "about2": '辦公室、教育、車盒等智慧硬體方案商',
		 "about3": '合作諮詢',
		 "about4": '公司簡介',
		 "about5": '資格認證',
		 "about6": '100多項國內外專利',
		 "about7": '深圳市貝鉑智能科技有限公司',
		 "about8": '貝鉑智能創立於2015年，立足中國「智造」中心深圳，是一家具有前瞻性眼光和創新精神的國家高新技術企業、專精特新企業。 ',
		 "about9": '公司專注於AI語音垂直細分領域，具有強大的AI軟體+硬體研發實力，透過輸出AI技術如AI語音、AI翻譯、AI OCR、AI人車互動、AI雲等賦能AI硬體。自研語音翻譯AI模型，融合最新AI多模態及AIGC技術，以晶片平台與硬體方案為基礎的研發設計，為不同領域的客戶提供全端式AI語音技術解決方案。在教育、商業化軍工等領域，公司有成熟的產業解決方案；在消費端，AI翻譯機、AI錄音筆、AI掃描筆AI車盒等AI硬體年銷售量超百萬台。公司在日本、歐美等國家地區擁有多個策略夥伴在幫助人類跨越語言障礙領域，是全球領先的AI語音技術解決方案提供者。 ',
		 "about10": '',
	},
	footer:{
		"AboutUs": '關於我們',
		 "CollaborativeConsulting": '合作諮詢',
		 "Businesscooperation": '商務合作',
		 "phone": '聯絡方式：',
		 "phone2": '+86 13660736734',
		 "phone3": 'hangou@szbbzn.com',
		 "tel": '0755 27189290',
		 "address": '深圳市龍華區大浪街道陶元社區元芬工業區F棟201',
		 "copyright": '版權所有  ©  深圳市貝鉑智能科技有限公司',
		 "icp": '粵ICP備2024241358號-1',
		 "footer2":'歡迎註冊',
		 "footer3":'已有帳號？ ',
		 "footer4":'請登入',
	},
	login:{
		"login1":'密碼登入',
		 "login2":'簡訊登入',
		 "loginTab3":'郵箱登入',
		 "login3":'郵箱',
		 "login4":'登入密碼',
		 "login5":'手機號碼',
		 "login6":'請選擇',
		 "login7":'手機驗證碼',
		 "login8":'登入',
		 "login9":'忘記密碼',
		 "login10":'註冊',
		 "login11":'登入即表示您同意',
		 "login12":'服務協定',
		 "login13":'隱私協定',
		 "login14":'獲取',
		 "login15":'中國',
		 "login16":'請輸入帳號',
		 "login17":'請輸入密碼',
		 "login18":'登入成功!',
		 "login19":'請輸入驗證碼!',
		 "login20":'發送成功!',
		 "login21":'和',
		 "login22":'錄音筆雲盤',
		 "login23":'我的寫作',
		 "login24":'我的對話',
		 "login25":'帳號安全',
		 "login26":'登出登入',
		 "login27":'郵箱找回密碼',
		 "login28":'郵箱',
		 "login29":'郵件信箱驗證碼',
		 "login30":'設定登入密碼（6-16位元字元）',
		 "login31":'再次輸入登入密碼',
		 "login32":'提交',
		 "login33":'返回登入',
		 "login34":'修改成功!',
	},
	register:{
		"register1":'手機號碼',
		 "register2":'請輸入您的手機',
		 "register3":'請選擇',
		 "register4":'手機驗證碼',
		 "register5":'設定密碼',
		 "register6":'請輸入驗證碼',
		 "register7":'6-16位元字元',
		 "register8":'密碼確認',
		 "register9":'郵箱',
		 "register10":'請輸入信箱',
		 "register11":'郵箱驗證碼',
		 "register12":'請輸入驗證碼',
		 "register13":'我已閱讀並同意',
		 "register14":'請閱讀並勾選同意協議',
		 "register15":'手機號碼格式錯誤 / 手機號碼已註冊',
		 "register16":'手機驗證碼錯誤',
		 "register17":'請輸入信箱 / 信箱格式錯誤',
		 "register18":'郵件信箱格式錯誤',
		 "register19":'郵箱驗證碼錯誤',
		 "register20":'密碼請設定6-16位元字元',
		 "register21":'密碼格式錯誤',
		 "register22":'兩次輸入的密碼不一致，請重新輸入',
		 "register23":'請輸入密碼',
		 "register24":'註冊成功!',
		 "register25":'驗證碼錯誤',
	},
	recorder:{
		"recorder1":'錄音筆雲盤',
		 "recorder2":'雲端空間容量',
		 "recorder3":'檔案',
		 "recorder331":'回收站',
		 "recorder332":'全部清除',
		 "recorder4":'名稱',
		 "recorder5":'音訊時長',
		 "recorder6":'檔案大小',
		 "recorder7":'創建時間',
		 "recorder8":'操作',
		 "recorder9":'雲端空間說明',
		 "recorder10":'檔案',
		 "recorder11":'OCR檔',
		 "recorder12":'1.雲端空間是用來做什麼的?',
		 "recorder13":'在錄音筆上錄音完成後，您可以上傳音訊和轉寫檔案至雲端空間，即使錄音筆不在身邊，您也可以進入雲空間查看音訊。 ',
		 "recorder14":'2.如何上傳雲端空間?',
		 "recorder15":'在錄音筆上進入【我的檔案】，選中目標檔案長按出現選項，點擊“上傳”，即可將檔案上傳至雲端空間。 ',
		 "recorder16":'3.如何檢視/管理雲端空間檔案?',
		 "recorder17":'登入貝鉑官網，選擇“我的-錄音筆雲盤”，就可以查看已經上傳的錄音筆檔案。您可以選擇目標檔案進行下載、刪除等操作。您可以透過刪除雲空間檔案來清理雲端空間的儲存哦!',
		 "recorder18":'未轉寫',
		 "recorder19":'查看摘要',
		 "recorder20":'講話人',
		 "recorder21":'編輯講話人名稱',
		 "recorder22":'確定',
		 "recorder23":'下載',
		 "recorder24":'下載內容：',
		 "recorder25":'下載設定：',
		 "recorder26":'顯示說話者',
		 "recorder27":'取消',
		 "recorder28":'連結分享',
		 "recorder29":'獲得連結的人都可以訪問，僅支援閱讀，連結7天有效',
		 "recorder30":'複製連結',
		 "recorder31":'掃一掃，快速檢視',
		 "recorder32":'智慧整理',
		 "recorder33":'區別說話者',
		 "recorder34":'依照講話人角色，智能區分轉寫文字',
		 "recorder35":'智慧型口語規則',
		 "recorder36":'自動過濾語氣詞、重複詞、停頓詞',
		 "recorder37":'非人聲過濾',
		 "recorder38":'播放時自動跳過無人聲，噪音的音訊',
		 "recorder39":'請選擇',
		 "recorder40":'文檔',
		 "recorder41":'音訊',
		 "recorder42":'文件+音訊',
		 "recorder43":'提示',
		 "recorder44":'此操作將刪除檔案, 是否繼續?',
		 "recorder441":'此操作將刪除全部檔案, 是否繼續?',
		 "recorder45":'確定',
		 "recorder46":'取消',
		 "recorder47":'刪除成功!',
		 "recorder48":'已取消刪除',
		 "recorder49":'暫無標記',
		 "recorder50":'正在儲存…',
		 "recorder51":'回收站',
	},
	personal:{
		"personal1":'帳戶設定',
		 "personal2":'個人資料',
		 "personal3":'頭像',
		 "personal4":'上傳檔案',
		 "personal5":'支援JPG、JPEG、GIF、PNG 風格，支援 2M 以內的圖片',
		 "personal6":'暱稱',
		 "personal7":'請輸入暱稱',
		 "personal8":'性別',
		 "personal9":'先生',
		 "personal10":'女士',
		 "personal11":'保密',
		 "personal12":'生日',
		 "personal13":'請選擇生日',
		 "personal14":'職業',
		 "personal15":'請選擇職業',
		 "personal16":'請輸入職業（非必填）',
		 "personal17":'國家',
		 "personal18":'請選擇國家',
		 "personal19":'保存',
		 "personal20":'個人資料',
		 "personal21":'帳戶安全',
		 "personal22":'只支援2M以內的圖片',
		 "personal23":'上傳成功!',
		 "personal24":'修改成功!',
		 "personal25":'帳戶安全',
		 "personal26":'登入密碼',
		 "personal27":'修改',
		 "personal28":'電子郵件',
		 "personal29":'更換',
		 "personal30":'帳號註銷',
		 "personal32":'確定註銷帳戶嗎？ ',
		 "personal33":'登出後，您在帳戶下的全部內容將全部清除，請謹慎操作。 ',
		 "personal34":'取消',
		 "personal35":'確定',
		 "personal36":'身份驗證',
		 "personal37":'為確認是您本人操作，請透過信箱驗證碼完成身份驗證',
		 "personal38":'郵箱',
		 "personal39":'驗證碼',
		 "personal40":'請輸入驗證碼',
		 "personal41":'下一步',
		 "personal42":'設定新信箱',
		 "personal43":'郵箱',
		 "personal44":'請輸入新信箱',
		 "personal45":'驗證碼',
		 "personal46":'請輸入驗證碼',
		 "personal47":'確定',
		 "personal48":'設定新登入密碼',
		 "personal49":'新登入密碼',
		 "personal50":'請輸入新密碼',
		 "personal51":'確認新密碼',
		 "personal52":'請再輸入新密碼',
		 "personal53":'確定',
		 "personal54":'獲取',
		 "personal55":'郵件信箱格式錯誤',
		 "personal56":'更換成功!',
		 "personal57":'密碼請設定6-16位元字元',
		 "personal58":'兩次輸入的密碼不一致',
		 "personal59":'修改成功!',
		 "personal60":'註銷成功!',
	}
}